module.exports = __webpack_public_path__ + "img/s45_thumb.e8f4d8f2.jpg";